import ExhibitorLogin from '../Exhibitor/Login/ExhibitorLogin';

const Home = () => {
  return (
    <>
      <ExhibitorLogin />
    </>
  );
};

export default Home;
